import { InfoCircleOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import styled from 'styled-components';

import { NeutralColors } from '@/theme/colors';

export const InfoIcon = styled(InfoCircleOutlined)`
  cursor: pointer;

  svg {
    width: 18px;
    height: 18px;
  }
`;

/**
 * Text for the tooltip slot. The antd Tooltip renders on a dark surface, so
 * default Typography text would be dark-on-dark and unreadable.
 */
export const MoreInfoText = styled(Typography.Text)`
  color: ${NeutralColors[0]};
`;

export const TooltipStyleWrapper = styled.span<{
  $width?: number;
  $dark?: boolean;
}>`
  ${({ $width, $dark }) => `
    .ant-tooltip-inner {
      ${$width ? `width: ${$width}px !important; max-width: ${$width}px !important;` : ''}
      word-break: break-word;
      white-space: normal;
      ${$dark ? `background-color: rgba(0, 0, 0, 0.85) !important;` : ''}
      ${$dark ? `color: rgba(255, 255, 255, 0.85) !important;` : ''}
    }
    ${$dark ? `.ant-tooltip-arrow-content { background-color: rgba(0, 0, 0, 0.85) !important; }` : ''}
  `}
`;
